import { useCallback, useState } from 'react';
import { useDealPromptDomainsContext } from '../utils/context/DealPromptDomainsContext';
import { type DealPromptTileItem, isCumulativeDealPromptTileItem } from '../utils/getTilesData';
import { dealPromptContextTypes } from '../utils/types';
import { useDealPrompt } from './useDealPrompt';

export const useDealPromptCreateDeal = () => {
  const {
    state: { contextType },
    createDeal,
  } = useDealPrompt();
  const { useDealPromptAudienceCreateDealSubmit } = useDealPromptDomainsContext();
  const submitAudienceCreateDeal = useDealPromptAudienceCreateDealSubmit();
  const [isAudienceCreateDealOpen, setAudienceCreateDealOpen] = useState(false);

  const handleCreateDeal = useCallback(
    (item: DealPromptTileItem) => {
      if (contextType === dealPromptContextTypes.AUDIENCE) {
        setAudienceCreateDealOpen(true);
      } else if (isCumulativeDealPromptTileItem(item)) {
        createDeal(item);
      }
    },
    [contextType, createDeal]
  );

  const closeAudienceCreateDealDialog = useCallback(() => setAudienceCreateDealOpen(false), []);

  return {
    isAudienceCreateDealOpen,
    handleCreateDeal,
    closeAudienceCreateDealDialog,
    submitAudienceCreateDeal,
  };
};
